// extracted by mini-css-extract-plugin
export default {"companyCard":"CompanyCard_companyCard__7tqEq","jobCount":"CompanyCard_jobCount__AEDhu"};